import { FormatUtils, PaletteUtils } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface RecentRecipientProps {
  recipient: RecipientResponse;
}

export const RecentRecipient = (props: RecentRecipientProps) => {
  return (
    <>
      <div className='mr-2 flex h-9 min-h-9 w-9 min-w-9 rounded-full bg-primary'>
        <Text className='m-auto' weight='semibold' color='white'>
          {FormatUtils.getRecipientInitials(props.recipient)}
        </Text>
      </div>
      <div className='flex flex-col'>
        <Text weight='semibold'>{FormatUtils.getRecipientName(props.recipient)}</Text>
        <Text className='text-nowrap' size='xs' color={PaletteUtils.isInsigniaPalette ? 'secondary' : 'gray'}>
          {props.recipient.iban || props.recipient.accountNumber || '-'}
        </Text>
      </div>
    </>
  );
};
